export const environment = {
  production: true,
  environmentName: '%ENVIRONMENT_NAME%',
  api: {
    dashboardHost: '%SYND_DASHBOARD_HOST%',
    metricsHost: '%SYND_COMPOSER_HOST%',
    sharingHost: '%SYND_SHARING_HOST%',
    identityHost: '%SYND_IDENTITY_HOST%',
    exportHost: '%SYND_EXPORT_HOST%',
    referenceDataPremiumHost: '%SYND_REFDATA_PREM_HOST%',
    referenceDataFreemiumHost: '%SYND_REFDATA_FREE_HOST%',
    featureFlags: '%SYND_FEATURE_FLAGS_HOST%',
    trackingHost: '%SYND_TRACKING_HOST%'
  },
  productType: '%PRODUCT_TYPE%',
  auth: {
    msalConfig: {
      clientId: '%SYND_APP_ID%',
      authority: 'https://login.microsoftonline.com/%SYND_APP_TENANT%',
      redirectUri: '%MSAL_REDIRECT_URI%'
    },
    scope: '%SYND_APP_ID_URI%/Backend.Access',
    trackingApiScope: '%SYND_TRACKING_API_SCOPE%'
  },
  exploreUri: '%SYND_EXPLORE_URI%',
  featureToggles: [],
  appVersion: '1.7.10-dev26102841434',
  logging: {
    connectionString: '%SYND_APP_INSIGHTS_CONN_STRING%'
  },
  pardot: {
    bookADemoIFrameUrl:
      'https://go.kantarmarketplace.com/l/73302/2020-04-09/pzg3vg'
  }
};
